/**
 * Reserved style number used to render deterministic dummy data inside interactive guides.
 *
 * It is intentionally truthy (unlike `0`) so the existing `skip: !styleNumber` query guards still
 * fire, and it has fewer digits than a real (8-digit) style number so it can never collide with one.
 */
const GUIDE_DUMMY_STYLE_NUMBER_ONE = 9999999;
const GUIDE_DUMMY_STYLE_NUMBER_TWO = 9999998;
const GUIDE_DUMMY_STYLE_NUMBERS = [
    GUIDE_DUMMY_STYLE_NUMBER_ONE,
    GUIDE_DUMMY_STYLE_NUMBER_TWO,
];

enum GuideTargets {
    bomKeyboardShortcutsButton = 'bom-keyboard-shortcuts-button',
    bomGroupComment = 'bom-group-comment',
    bomManageOptionsDialog = 'bom-manage-options-dialog',
    bomManageOptionsButton = 'bom-manage-options-button',
    bomUsageCellColumn = 'bom-usage-cell-column',
    bomMaterialCellColumn = 'bom-material-cell-column',
    bomPlacementCellColumn = 'bom-placement-cell-column',
    bomConsumptionCellColumn = 'bom-consumption-cell-column',
    bomColourActionsCellColumn = 'bom-colour-actions-cell-column',
    bomUsageButtonsRow = 'bom-usage-buttons-row',
    viewBomActionButton = 'view-bom-action-button',
    stylesTable = 'styles-table',
    viewBomGroup = 'view-bom-group',
    // Prefix only; combine with a row index via `getStylesTableRowGuideTarget`.
    stylesTableRowPrefix = 'styles-table-row',
}

/** Builds the per-row guide target for a styles table row at the given index. */
const getStylesTableRowGuideTarget = (index: number): string =>
    `${GuideTargets.stylesTableRowPrefix}-${index}`;

export {
    GUIDE_DUMMY_STYLE_NUMBER_ONE,
    GUIDE_DUMMY_STYLE_NUMBER_TWO,
    GUIDE_DUMMY_STYLE_NUMBERS,
    GuideTargets,
    getStylesTableRowGuideTarget,
};
